export default [
  {
    path: "breedingManagement",
    name: "养殖管理",
    component: () =>
      import("../views/agricultureManagement/breedingManagement/index.vue"),
  },
  {
    path: "landManage",
    name: "土地管理",
    component: () =>
      import("../views/agricultureManagement/landManage/index.vue"),
  },
  {
    path: "plantingAndBreedingSite",
    name: "种养场地管理",
    component: () =>
      import(
        "../views/agricultureManagement/plantingAndBreedingSite/index.vue"
      ),
  },
  {
    path: "plantingManagement",
    name: "种植管理",
    component: () =>
      import("../views/agricultureManagement/plantingManagement/index.vue"),
  },
  {
    path: "fisheryManagement",
    name: "渔业管理",
    component: () =>
      import("../views/agricultureManagement/fisheryManagement/index.vue"),
  },
  {
    path: "infobatchManage",
    name: "信息直报批次管理",
    component: () =>
      import("../views/agricultureManagement/infoBatchManage/index.vue"),
  },
  {
    path: "productCategory",
    name: "产品品类管理",
    component: () =>
      import("../views/agricultureManagement/productCategory/index.vue"),
  },
  {
    path: "agricultureGrid",
    name: "网格管理",
    component: () =>
      import("../views/agricultureManagement/agricultureGrid/index.vue"),
  },
  {
    path: "griderList",
    name: "网格员列表",
    component: () =>
      import("../views/agricultureManagement/griderList/index.vue"),
  },
];
